module.exports = __webpack_public_path__ + "static/img/lxcxBg.41bf66c5.svg";